module.exports = __webpack_public_path__ + "static/media/21ECLAC29.ff44c616.jpg";